import LoginRouter from "./router/login-router";

export default [LoginRouter];